/* tslint:disable */
/* eslint-disable */
/**
 * FMS Run API
 * The FMS Run API description
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { ExternalBarangayDto } from '../model';
// @ts-ignore
import type { ExternalCityMunicipalityDto } from '../model';
// @ts-ignore
import type { ExternalProvinceDto } from '../model';
// @ts-ignore
import type { PlacesControllerGetPhilippinesHealthCheck200Response } from '../model';
// @ts-ignore
import type { QatarProvinceDto } from '../model';
// @ts-ignore
import type { QatarProvincesResponseDto } from '../model';
/**
 * PlacesApi - axios parameter creator
 * @export
 */
export const PlacesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get barangays for a Philippines city/municipality
         * @param {string} cityMunicipalityCode City/municipality code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesBarangays: async (cityMunicipalityCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'cityMunicipalityCode' is not null or undefined
            assertParamExists('placesControllerGetPhilippinesBarangays', 'cityMunicipalityCode', cityMunicipalityCode)
            const localVarPath = `/api/places/philippines/cities-municipalities/{cityMunicipalityCode}/barangays`
                .replace(`{${"cityMunicipalityCode"}}`, encodeURIComponent(String(cityMunicipalityCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get cities/municipalities for a Philippines province
         * @param {string} provinceCode Province code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesCitiesMunicipalities: async (provinceCode: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'provinceCode' is not null or undefined
            assertParamExists('placesControllerGetPhilippinesCitiesMunicipalities', 'provinceCode', provinceCode)
            const localVarPath = `/api/places/philippines/provinces/{provinceCode}/cities-municipalities`
                .replace(`{${"provinceCode"}}`, encodeURIComponent(String(provinceCode)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Health check for Philippines external API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesHealthCheck: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/places/philippines/health`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Philippines provinces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesProvinces: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/places/philippines/provinces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Qatar province by code
         * @param {string} code Province code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetQatarProvinceByCode: async (code: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'code' is not null or undefined
            assertParamExists('placesControllerGetQatarProvinceByCode', 'code', code)
            const localVarPath = `/api/places/qatar/provinces/code/{code}`
                .replace(`{${"code"}}`, encodeURIComponent(String(code)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Qatar province by name
         * @param {string} name Province name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetQatarProvinceByName: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('placesControllerGetQatarProvinceByName', 'name', name)
            const localVarPath = `/api/places/qatar/provinces/name/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get all Qatar provinces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetQatarProvinces: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/places/qatar/provinces`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PlacesApi - functional programming interface
 * @export
 */
export const PlacesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PlacesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get barangays for a Philippines city/municipality
         * @param {string} cityMunicipalityCode City/municipality code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetPhilippinesBarangays(cityMunicipalityCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalBarangayDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetPhilippinesBarangays(cityMunicipalityCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetPhilippinesBarangays']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get cities/municipalities for a Philippines province
         * @param {string} provinceCode Province code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetPhilippinesCitiesMunicipalities(provinceCode: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalCityMunicipalityDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetPhilippinesCitiesMunicipalities(provinceCode, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetPhilippinesCitiesMunicipalities']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Health check for Philippines external API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetPhilippinesHealthCheck(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<PlacesControllerGetPhilippinesHealthCheck200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetPhilippinesHealthCheck(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetPhilippinesHealthCheck']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Philippines provinces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetPhilippinesProvinces(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ExternalProvinceDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetPhilippinesProvinces(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetPhilippinesProvinces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Qatar province by code
         * @param {string} code Province code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetQatarProvinceByCode(code: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QatarProvinceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetQatarProvinceByCode(code, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetQatarProvinceByCode']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Qatar province by name
         * @param {string} name Province name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetQatarProvinceByName(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QatarProvinceDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetQatarProvinceByName(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetQatarProvinceByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get all Qatar provinces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async placesControllerGetQatarProvinces(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<QatarProvincesResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.placesControllerGetQatarProvinces(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PlacesApi.placesControllerGetQatarProvinces']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PlacesApi - factory interface
 * @export
 */
export const PlacesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PlacesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get barangays for a Philippines city/municipality
         * @param {string} cityMunicipalityCode City/municipality code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesBarangays(cityMunicipalityCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalBarangayDto>> {
            return localVarFp.placesControllerGetPhilippinesBarangays(cityMunicipalityCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get cities/municipalities for a Philippines province
         * @param {string} provinceCode Province code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesCitiesMunicipalities(provinceCode: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalCityMunicipalityDto>> {
            return localVarFp.placesControllerGetPhilippinesCitiesMunicipalities(provinceCode, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Health check for Philippines external API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesHealthCheck(options?: RawAxiosRequestConfig): AxiosPromise<PlacesControllerGetPhilippinesHealthCheck200Response> {
            return localVarFp.placesControllerGetPhilippinesHealthCheck(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Philippines provinces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetPhilippinesProvinces(options?: RawAxiosRequestConfig): AxiosPromise<Array<ExternalProvinceDto>> {
            return localVarFp.placesControllerGetPhilippinesProvinces(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Qatar province by code
         * @param {string} code Province code
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetQatarProvinceByCode(code: string, options?: RawAxiosRequestConfig): AxiosPromise<QatarProvinceDto> {
            return localVarFp.placesControllerGetQatarProvinceByCode(code, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Qatar province by name
         * @param {string} name Province name
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetQatarProvinceByName(name: string, options?: RawAxiosRequestConfig): AxiosPromise<QatarProvinceDto> {
            return localVarFp.placesControllerGetQatarProvinceByName(name, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get all Qatar provinces
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        placesControllerGetQatarProvinces(options?: RawAxiosRequestConfig): AxiosPromise<QatarProvincesResponseDto> {
            return localVarFp.placesControllerGetQatarProvinces(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PlacesApi - object-oriented interface
 * @export
 * @class PlacesApi
 * @extends {BaseAPI}
 */
export class PlacesApi extends BaseAPI {
    /**
     * 
     * @summary Get barangays for a Philippines city/municipality
     * @param {string} cityMunicipalityCode City/municipality code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetPhilippinesBarangays(cityMunicipalityCode: string, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetPhilippinesBarangays(cityMunicipalityCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get cities/municipalities for a Philippines province
     * @param {string} provinceCode Province code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetPhilippinesCitiesMunicipalities(provinceCode: string, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetPhilippinesCitiesMunicipalities(provinceCode, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Health check for Philippines external API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetPhilippinesHealthCheck(options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetPhilippinesHealthCheck(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Philippines provinces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetPhilippinesProvinces(options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetPhilippinesProvinces(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Qatar province by code
     * @param {string} code Province code
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetQatarProvinceByCode(code: string, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetQatarProvinceByCode(code, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Qatar province by name
     * @param {string} name Province name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetQatarProvinceByName(name: string, options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetQatarProvinceByName(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get all Qatar provinces
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PlacesApi
     */
    public placesControllerGetQatarProvinces(options?: RawAxiosRequestConfig) {
        return PlacesApiFp(this.configuration).placesControllerGetQatarProvinces(options).then((request) => request(this.axios, this.basePath));
    }
}

